import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';

// Spaltenkopf, der den `sort`-Parameter im Format "<feld>:<asc|desc>" dreht.
// Die Sortierung selbst passiert serverseitig (Whitelist im Controller) —
// hier wird nur der URL-Parameter gesetzt.

const SortableHeader = ({
  field,
  label,
  sort,
  onSortChange,
  className = '',
  first = false,
}) => {
  const [activeField, activeDirection] = (sort || '').split(':');
  const isActive = activeField === field;
  const nextDirection = isActive && activeDirection === 'asc' ? 'desc' : 'asc';

  return (
    <th
      scope="col"
      className={`${
        first ? 'py-3.5 pl-4 pr-3 sm:pl-3' : 'px-3 py-3.5'
      } text-left text-sm font-semibold text-gray-900 ${className}`}
      aria-sort={
        isActive
          ? activeDirection === 'asc'
            ? 'ascending'
            : 'descending'
          : 'none'
      }
    >
      <button
        type="button"
        onClick={() => onSortChange(`${field}:${nextDirection}`)}
        className="group inline-flex items-center gap-1 focus:outline-none hover:cursor-pointer"
      >
        {label}
        <span
          className={`flex-none rounded-sm ${
            isActive
              ? 'bg-svisit-primary-100 text-svisit-primary-700'
              : 'invisible text-gray-400 group-hover:visible group-focus:visible'
          }`}
        >
          {isActive && activeDirection === 'asc' ? (
            <ChevronUpIcon className="size-5" aria-hidden="true" />
          ) : (
            <ChevronDownIcon className="size-5" aria-hidden="true" />
          )}
        </span>
      </button>
    </th>
  );
};

export default SortableHeader;
